import React from 'react'
import { View, TouchableOpacity, StyleSheet } from 'react-native'
import styled from 'styled-components'
import { Text } from 'react-native-paper'
import { useTranslation } from 'react-i18next'
import { AddIcon as OriginalAddIcon } from '../../../../assets/icons'
import { BtText } from '@linqpal/components/src/ui'

type AddPaymentMethodButtonsProps = {
  onAddCardPress: () => void
  phoneNumber: string
}
const AddIcon = styled(OriginalAddIcon)`
  opacity: ${({ opacity }) => opacity || 1};
`

const AddPaymentMethodButtons: React.FC<AddPaymentMethodButtonsProps> = ({
  onAddCardPress,
  phoneNumber,
}) => {
  const { t } = useTranslation('global')
  const isDisabled = !phoneNumber

  return (
    <View style={styles.container}>
      {/* Add Card Payment Button */}
      <TouchableOpacity
        style={
          isDisabled
            ? [styles.button, styles.cardButton, styles.cardButtonDisabled]
            : [styles.button, styles.cardButton]
        }
        onPress={onAddCardPress}
        disabled={isDisabled}
      >
        <View style={styles.iconWrapper}>
          <AddIcon opacity={isDisabled ? 0.3 : 1} />
        </View>
        <Text
          style={
            isDisabled
              ? [styles.buttonText, styles.buttonTextDisabled]
              : styles.buttonText
          }
        >
          {t(
            'integrations.pay-as-guest.payment-method-section.add-card-payment',
          )}
        </Text>
      </TouchableOpacity>
      {!phoneNumber && (
        <BtText style={styles.phoneNumberHint}>
          {t('integrations.pay-as-guest.payment-method-section.add-card-hint')}
        </BtText>
      )}
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    minHeight: 64,
    maxHeight: 80,
    marginTop: 3,
  },
  button: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    height: 48,
    borderRadius: 12,
    paddingHorizontal: 16,
  },
  cardButton: {
    backgroundColor: '#F4F9FD',
    borderWidth: 2,
    borderColor: '#00A0F3',
  },
  cardButtonDisabled: {
    borderWidth: 2,
    borderColor: 'rgba(0, 160, 243, 0.3)',
  },
  bankButton: {
    backgroundColor: '#F8F9F9',
  },
  iconWrapper: {
    marginRight: 8,
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonText: {
    fontSize: 14,
    lineHeight: 20,
    fontFamily: 'Inter',
    fontWeight: '700',
    color: '#001929',
  },
  buttonTextDisabled: {
    color: 'rgba(0, 25, 41, 0.3)',
  },
  phoneNumberHint: {
    fontWeight: '400',
    fontSize: 12,
    lineHeight: 16,
    fontFamily: 'Inter',
    color: '#001929',
    marginTop: 10,
    marginBottom: 20,
  },
})

export default AddPaymentMethodButtons
